// extracted by mini-css-extract-plugin
export var button = "_8y-7";
export var buttonRow = "_8y-6";
export var fadeIn = "_8y-1";
export var gradient = "_8y-0";
export var panel = "_8y-2";
export var panelIn = "_8y-3";
export var subtitle = "_8y-5";
export var title = "_8y-4";